export default __webpack_public_path__ + "static/media/visa.a256fe8d.png";